// hooks/useEventState.js
import { useState } from "react";

export const useEventState = () => {
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  return {
    eventData,
    setEventData,
    loading,
    setLoading,
    filter,
    setFilter,
  };
};